import React from "react";

const Display = ({result}) => {
  return (<div className="result">{result}</div>);
};

export default Display;